/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_Zoom_Hint_TitleInputs */

const en_ui_filter_zoom_hint_title = /** @type {(inputs: Ui_Filter_Zoom_Hint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take a closer look?`)
};

const de_ui_filter_zoom_hint_title = /** @type {(inputs: Ui_Filter_Zoom_Hint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genauer hinsehen?`)
};

/**
* | output |
* | --- |
* | "Take a closer look?" |
*
* @param {Ui_Filter_Zoom_Hint_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_zoom_hint_title = /** @type {((inputs?: Ui_Filter_Zoom_Hint_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Zoom_Hint_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_zoom_hint_title(inputs)
	return de_ui_filter_zoom_hint_title(inputs)
});